import { get, post } from '../../utils/request'

// 公众号二维码
const getQrCode = post('/news/heaQrCode/api/getAll')

export {
    getQrCode
}



// WEBPACK FOOTER //
// ./src/api/qrcode/qrcode.js